export default __webpack_public_path__ + "static/media/262.6af5bb19.png";